class Ingredients extends HTMLElement {
  constructor() {
    super()
    this.ingredientTabs = this.querySelectorAll('.ingredients__item')
    this.activeTabId = null

    this.ingredientTabs.forEach(ingredient => {
      ingredient.addEventListener('click', ()=> {
        this.activeTabId = ingredient.dataset.id
        this.changeTab(true)
      })
      ingredient.addEventListener('mouseover', ()=> {
        this.activeTabId = ingredient.dataset.id
        this.changeTab(false)
      })
    })
  }

  changeTab(scroll) {
   this.disableActiveTab()
   let activeContent = this.querySelector(`.ingredients__description-item[data-id="${this.activeTabId}"]`)
   activeContent.classList.add('ingredients__description-item--active')
   this.querySelector(`.ingredients__item[data-id="${this.activeTabId}"]`).classList.add('ingredients__item--active')
   if (scroll) activeContent.scrollIntoView({ block: "center", behavior: "smooth" })
  }

  disableActiveTab() {
    this.querySelector('.ingredients__item--active').classList.remove('ingredients__item--active')
    this.querySelector('.ingredients__description-item--active').classList.remove('ingredients__description-item--active')
  }
}

customElements.define('ingredients-info', Ingredients)